<footer data-testid="app-footer">
  <p>{{ applicationName }}</p>
  <p>&copy; AstraZeneca {{ copyrightYear }}</p>
</footer>
